import React from 'react';

// Components
import { HeaderRenderer } from '../HeaderRenderer';
import { ImpactRenderer } from './ImpactRenderer';

// Lib
import {
	DataColumn,
	RendererApi,
	CellRenderProps,
	HeaderRenderProps,
	SortDirection,
} from '../../types';

export const TextRendererName = 'Impact Renderer';

export interface Options extends DataColumn {
	onToggleSort?: (direction: SortDirection) => void;
}

export interface TextRendererApi extends RendererApi {}

export const useImpactRenderer = (options: Options): TextRendererApi => {
	const { field, label, width, sort } = options;

	const renderHeader = (props: HeaderRenderProps) => {
		return (
			<HeaderRenderer
				key={`${props.columnIndex}-${props.rowIndex}`}
				onToggleSort={options.onToggleSort}
				{...props}
				align="center"
			/>
		);
	};

	const renderCell = (props: CellRenderProps) => {
		return (
			<ImpactRenderer
				key={`${props.columnIndex}-${props.rowIndex}`}
				{...props}
			/>
		);
	};

	return {
		name: TextRendererName,
		type: 'Data',
		field,
		label,
		width,
		sort,
		renderHeader,
		renderCell,
	};
};
